module.exports = __webpack_public_path__ + "img/11.9f059aa8.png";